export default "__VITE_ASSET__CqDeOJpP__"